import React, { memo, useContext, useRef } from 'react';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import { ModalContext } from 'src/contexts/modal-context';
import { IFilterSelectItems } from '@redux/slices/order';
import { SearchGroup } from '@components/input';
import { ExportButton } from '@styles/components/button';
import { translate } from '@components/i18n';
import { exportTransferItems, fetchTransferItems, fetchTransferItemsByUser, importTransferItems } from '@redux/slices/transfer-item';
import { authSelector } from '@redux/slices/auth';
import { DownloadOutlined, ImportOutlined } from '@ant-design/icons';
import { EditModal } from './edit-modal';

export const Header: React.FC = memo(() => {
    const { pathname } = useLocation()
    const isRegister = pathname.includes("/register")

    const refInput = useRef<HTMLInputElement>(null)

    const dispatch = useDispatch();
    const modalContext = useContext(ModalContext);
    const authState = useSelector(authSelector)

    const filter = (filter: Partial<IFilterSelectItems>): void => {
        if (authState.isAdmin) {
            dispatch(
                fetchTransferItems({
                    page: 0,
                    size: 10,
                    query: filter.filterValue,
                    sort: 'numero,asc'
                }),
            );
        } else {
            dispatch(
                fetchTransferItemsByUser({
                    page: 0,
                    size: 10,
                    query: filter.filterValue,
                    sort: 'numero,asc'
                }),
            );
        }
    };

    const add = (): void => {
        modalContext.setIsOpen(true, <EditModal />, {
            title: translate('general.registerItem'),
            width: '40%',
        });
    };

    const importItems = (files: FileList) => {
        const formData = new FormData()

        formData.append("file", files[0])

        dispatch(importTransferItems(formData))

        if (refInput.current) {
            refInput.current.value = ""
        }
    }

    const openInput = (): void => {
        if (!refInput.current) return
        refInput.current.click()
    };

    const exportItems = (): void => {
        dispatch(exportTransferItems())
    };

    return (
        <Col>
            <Row style={{ marginTop: 20 }} align="middle">
                <Col span={24}>
                    <Row justify={'space-between'} align="middle">
                        <Col span={10}>
                            <SearchGroup
                                allowClear
                                placeholder={translate(
                                    'forms.placeholders.search',
                                )}
                                onSearch={(e) => {
                                    filter({ filterValue: e });
                                }}
                            />
                        </Col>
                        <Col span={14}>
                            <Row justify="end">
                                {authState.isAdmin && (
                                    <>
                                        <input
                                            ref={refInput}
                                            type='file'
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            style={{ display: 'none' }}
                                            onChange={(e) => importItems(e.target.files)}
                                        />
                                        <ExportButton onClick={openInput}>
                                            {translate('general.import')} <ImportOutlined />
                                        </ExportButton>

                                        <ExportButton onClick={exportItems}>
                                            {translate('general.export')} <DownloadOutlined />
                                        </ExportButton>
                                    </>
                                )}

                                {isRegister && (
                                    <ExportButton onClick={add}>
                                        {translate('forms.buttons.addNew')}
                                    </ExportButton>
                                )}
                            </Row>
                        </Col>

                    </Row>
                </Col>
            </Row>
        </Col>
    );
});
